/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Ionicons } from '@expo/vector-icons';
import { Text, TouchableOpacity, View } from 'react-native';
import { ticketColors } from '../../../shared/theme/ticketColors';
import { styles } from './CatalogMastersScreen.styles';

type Props = {
  canEdit: boolean;
  editingMode: boolean;
  csvLabel?: string;
  createLabel: string;
  onOpenCsv?: () => void;
  onCreate: () => void;
  /** Canonical taxonomy: allow CSV / actions without "Agregar". */
  hideCreate?: boolean;
};

export function MastersSectionHeader({
  canEdit,
  editingMode,
  csvLabel = 'CSV',
  createLabel,
  onOpenCsv,
  onCreate,
  hideCreate = false,
}: Props) {
  if (editingMode) return null;

  const showCreate = canEdit && !hideCreate;
  if (!showCreate && !onOpenCsv) return null;

  const isPlusOnly = createLabel === '+';

  return (
    <View style={styles.sectionHeroActions}>
      {onOpenCsv ? (
        <TouchableOpacity
          style={styles.secondaryButton}
          onPress={onOpenCsv}
          accessibilityRole="button"
          accessibilityLabel="Importar o exportar CSV"
        >
          <Ionicons name="document-text-outline" size={14} color={ticketColors.ink2} />
          <Text style={styles.secondaryButtonText}>{csvLabel}</Text>
        </TouchableOpacity>
      ) : null}
      {showCreate ? (
        <TouchableOpacity
          style={[styles.primaryButton, isPlusOnly && styles.primaryButtonIconOnly]}
          onPress={onCreate}
          accessibilityRole="button"
          accessibilityLabel={createLabel === '+' ? 'Agregar' : createLabel}
        >
          <Text style={styles.primaryButtonText}>{createLabel}</Text>
        </TouchableOpacity>
      ) : null}
    </View>
  );
}
